export default __webpack_public_path__ + "static/poster-efbefe49f0128756edc47b0353dd1d4d.png";